// 登陆
// --------------

/* 初始化登录 */
export var LOGIN_INIT = '/lgn/login/init.do';
/* 账号密码登录接口(邮箱/手机号+密码登录) */

export var LOGIN_VERIFY = '/lgn/login/verify.do';
/* 发送验证码 */

export var LOGIN_SEND_SMS = '/lgn/login/sendSms.do';
/* 验证登录 */

export var LOGIN_VERIFY_SMS = '/lgn/login/verifySms.do';
/* 第三方登录 */

export var THIRD_LOGIN = '/lgn/third/open/loginAndBind.do';
/* 三方登录账号与邮箱流程 发送邮箱验证码 */

export var THIRD_SEND_EMAIL_CODE = '/lgn/third/open/common/bindEmail/sendEmailCode.do';
/* 三方登录账号与邮箱流程 绑定邮箱 */

export var THIRD_BIND_EMAIL = '/lgn/third/open/common/bindEmailAccount.do';
/** 三方登录账号与邮箱流程 发送手机验证码 */

export var THIRD_SEND_MOBILE_CODE = '/lgn/third/open/common/bindMobile/sendMobileCode.do';
/** 三方登录账号与邮箱流程 验证手机验证码并绑定手机 */

export var THIRD_BIND_MOBILE = '/lgn/third/open/common/bindMobileAccount.do';
/* 绑定三方登录账号与uid接口*/

export var BIND_UID_ACCOUNT = '/lgn/third/open/bindUidAccount.do';
/* 继续绑定接口 （用于终端流程补充用户信息）*/

export var LOGIN_AND_BIND_TOKEN = '/lgn/third/open/thirdLoginAndBindByBindToken.do'; // 融合注册
// --------------

/* 初始化注册 - 融合注册 */

export var MIX_REGISTER_INIT = '/reg/registermix/init.do';
/* 校验用户 - 融合注册 */

export var MIX_REGISTER_CHECK = '/reg/register/checkacct.do';
/* 发送验证码（可选）- 融合注册 */

export var MIX_REGISTER_SEND_VERIFY_CODE = '/reg/register/sendverifycode.do';
/* 注册 - 融合注册 */

export var MIX_REGISTER_REGCORE = '/reg/registermix/regcore.do'; // 商家注册
// ------------

/* 初始化注册 - 商家注册 */

export var REGISTER_ADMIN_INIT = '/reg/registeradmin/init.do';
/* 发送验证码 - 商家注册 */

export var REGISTER_ADMIN_SEND_VERIFY_CODE = '/reg/registeradmin/sendverifycode.do';
/* 注册 - 商家注册 */

export var REGISTER_ADMIN_REGCORE = '/reg/registeradmin/regcore.do'; // 统一认证
// -----------

/* 获取验证手段列表 */

export var UNI_GET_METHOD_LIST = '/aq/uni/getMethodList.do';
/* 验证 */

export var UNI_SEND_SMS = '/aq/uni/sendSms.do';
/* 验证短信验证码 */

export var UNI_VERIFY_SMS = '/aq/uni/verifySms.do';
/* 邮箱验证码验证 */

export var UNI_SEND_EMAIL_CODE = '/aq/uni/sendEmailCode.do';
/* 验证邮箱验证码 */

export var UNI_VERIFY_EMAIL_CODE = '/aq/uni/verifyEmailCode.do';
/* 通过验证 */

export var UNI_PASS = '/aq/uni/pass.do';
/* 密码验证(password) */

export var UNI_VERIFY_PASSWORD = '/aq/uni/verifyPassword.do'; // 激活
// ------------

/* 初始化激活 */

export var PWD_ACTIVATE_INIT = '/aq/pwd/activate/code/init.do';
/* 检查账号 */

export var PWD_ACTIVATE_PRECHK = '/aq/pwd/activate/code/prechk.do';
/* 改密激活账号 */

export var PWD_ACTIVATE_MODIFY = '/aq/pwd/activate/code/modify.do'; // 忘记密码
// -----------

/* 初始化忘记密码 */

export var PWD_RETRIEVE_INIT = '/aq/pwd/retrieve/init.do';
/* 检查账号(手机号/邮箱) */

export var PWD_RETRIEVE_PRECHK = '/aq/pwd/retrieve/prechk.do';
/* 改密 */

export var PWD_RETRIEVE_MODIFY = '/aq/pwd/retrieve/modify.do'; // 修改密码
// -----------

/* 初始化修改密码 */

export var PWD_CHANGE_INIT = '/aq/pwd/change/init.do';
/* 修改密码 */

export var PWD_CHANGE_MODIFY = '/aq/pwd/change/modify.do'; // 绑定/改绑手机
// -----------

/* 初始化 - 绑定/改绑手机 */

export var MOBILE_BIND_INIT = '/aq/mobile/bind/init.do';
/* 向新手机发送短信验证码 - 绑定/改绑手机 */

export var MOBILE_BIND_SEND_SMS = '/aq/mobile/bind/sendSms.do';
/* 绑定/改绑手机 - 绑定/改绑手机 */

export var MOBILE_BIND_BIND = '/aq/mobile/bind/bind.do'; // 绑定/改绑邮箱
// -----------

/* 初始化 - 绑定/改绑邮箱 */

export var EMAIL_BIND_INIT = '/aq/email/bind/init.do';
/* 向新邮箱发送验证码 - 绑定/改绑邮箱 */

export var EMAIL_BIND_SEND_CODE = '/aq/email/bind/sendCode.do';
/* 绑定/改绑邮箱 - 绑定/改绑邮箱 */

export var EMAIL_BIND_BIND = '/aq/email/bind/bind.do'; // 邀请注册设置密码
// -----------

/* 初始化 - 邀请注册设置密码 */

export var PWD_REG_INIT = '/aq/pwd/reg/init.do';
/* 设置密码 - 邀请注册设置密码 */

export var PWD_REG_MODIFY = '/aq/pwd/reg/modify.do';